import { LocalizationStore } from '@/stores/localization/store';
import { createContext } from 'react';

export const LocalizationContext = createContext<LocalizationStore | null>(
  null,
);
